<template>
<div class="chapter">
<div class="inner_page">
<p class="extract"><br/><br/></p>
<p class="center"><a id="pagev"></a><em>To Max Youngstein,<br/>and not only for reasons of affection and admiration,<br/>this book is warmly dedicated</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?1675dc34